import React, { useState } from 'react';
import { auth, googleProvider } from '../firebase';
import { Logo } from './icons/Logo';
import { GoogleIcon } from './icons/InterfaceIcons';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export const SignIn = ({ onNavigateToSignUp }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await auth.signInWithEmailAndPassword(email, password);
      // onAuthStateChanged in App.tsx will handle the rest
    } catch (error) {
      if (error.code === 'auth/invalid-credential' || error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        setError('Invalid email or password.');
      } else {
        setError('Failed to sign in. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setError('');
    setLoading(true);
    try {
      await auth.signInWithPopup(googleProvider);
      // onAuthStateChanged will handle the rest
    } catch (error) {
      setError('Failed to sign in with Google. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex-1 flex items-center justify-center p-4 bg-brand-bg">
      <Helmet>
        <title>Sign In - TestSeries</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="w-full max-w-md mx-auto bg-brand-surface rounded-2xl shadow-card border border-brand-border p-8">
        <div className="text-center mb-8">
            <Logo size="large" />
          <h1 className="text-2xl font-bold text-brand-text-primary mt-4">Sign in to your account</h1>
          <p className="text-brand-text-secondary mt-2">
            Don't have an account?{' '}
            <button onClick={onNavigateToSignUp} className="font-semibold text-brand-primary hover:text-brand-primary-hover">
              Sign up
            </button>
          </p>
        </div>
        
        <div className="space-y-4">
          <button type="button" onClick={handleGoogleSignIn} disabled={loading} className="w-full flex justify-center items-center py-3 px-4 border border-brand-border rounded-md shadow-sm text-sm font-medium text-brand-text-primary bg-white hover:bg-gray-50 disabled:opacity-50">
            <GoogleIcon className="w-5 h-5 mr-3" />
            Continue with Google
          </button>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-brand-border" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-brand-surface text-brand-text-secondary">OR</span>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="mt-4 space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-brand-text-primary">
              Email address
            </label>
            <div className="mt-1">
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="block w-full px-3 py-2 border border-brand-border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm bg-brand-surface text-brand-text-primary"
                placeholder="you@example.com"
              />
            </div>
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-brand-text-primary">
              Password
            </label>
            <div className="mt-1">
              <input
                id="password"
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="block w-full px-3 py-2 border border-brand-border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm bg-brand-surface text-brand-text-primary"
                placeholder="••••••••"
              />
            </div>
          </div>
          
          {error && <p className="text-sm text-brand-accent-red text-center">{error}</p>}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-primary hover:bg-brand-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary disabled:opacity-50"
            >
              {loading ? 'Signing In...' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
};